
import Helmet from '../components/Helmet'
import CustomFooter from '../components/FooterCustom'
import Profile from '../components/Profile'
import { Content } from 'antd/lib/layout/layout'
import ProjectList from '../components/ProjectList'
import SelfInfo from '../components/Self_Info'
import { AffixVideo } from '../components/AffixVideographer'

const MainPage = () => {
  return (
    <div className="mainBackground">
      <Content>
        <Helmet />
        <AffixVideo/>
        <Profile displaycaption={true} />
        <SelfInfo />
        <ProjectList />
      </Content>
      <CustomFooter />
    </div>
  )
}

export default MainPage
